export default __webpack_public_path__ + "static/service-shape4-dd901122ff2e90bc090dc7cc0ef24fc7.png";